import React from "react";
import { BadgeCheck, Scale, Tag } from "lucide-react";
import { eur } from "@/lib/pa";

export const MepaBadge = ({ note }) => (
  <span data-testid="mepa-badge" title={note ? `Bandi Consip: ${note}` : "Abilitazione MePA dichiarata dall'operatore"}
    className="inline-flex items-center gap-1 text-xs font-bold px-3 py-1 rounded-full bg-[#0B5394] text-white border border-[#0B5394] tracking-wide">
    <BadgeCheck className="w-4 h-4"/>Abilitato MePA
  </span>
);

export const CpvList = ({ cpv }) => (
  <div className="flex flex-wrap gap-2 mt-3" data-testid="profile-cpv">
    {(cpv || []).map((c) => (
      <span key={c.code} title={c.label} className="inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-full border border-slate-300 text-slate-700 bg-white">
        <Tag className="w-3 h-3 text-gold"/>CPV <b className="font-mono">{c.code}</b><span className="hidden sm:inline text-slate-500">· {c.label}</span>
      </span>
    ))}
  </div>
);

export const SplitPaymentBox = ({ q }) => {
  if (!q?.splitPayment) return null;
  return (
    <div className="rounded-xl border border-gold/60 bg-gold/10 p-3 space-y-1.5 text-xs" data-testid="split-payment-box">
      <div className="font-bold text-gold flex items-center gap-1.5"><Scale className="w-4 h-4"/>Split Payment (art. 17-ter DPR 633/72)</div>
      <div className="flex justify-between"><span>Da pagare all'operatore (imponibile)</span><span className="font-semibold" data-testid="split-to-operator">{eur(q.payableToOperator)}</span></div>
      <div className="flex justify-between"><span>IVA versata dall'Ente all'Erario</span><span className="font-semibold" data-testid="split-to-erario">{eur(q.vatToErario)}</span></div>
    </div>
  );
};
